import { PreviewDocumentParams } from 'src/utils/FileUtils';

// Federation Event Constants
export const FederationEvent = {
  AUTH_TOKEN_RECEIVED: 'auth-token-received',
  FEATURE_FLAGS_UPDATED: 'feature-flags-updated',
  APPD_CONFIG_UPDATED: 'appd-config-updated',
  INTERCOM_AVAILABILITY_UPDATED: 'intercom-availability-updated',
  INTERCOM_MESSENGER_AVAILABILITY_UPDATED: 'intercom-messenger-availability-updated',
} as const;

// Feature flags interface
export interface FeatureFlagValues {
  'fnx-show-backtodocuments'?: boolean;
  'enable-dynamic-questionnaire'?: boolean;
  [key: string]: boolean | string | number | undefined;
}

// AppDynamics configuration interface for federation
export interface AppDynamicsConfigPayload {
  user: any | null;
  appKey: string;
  adrumExtUrlHttps: string;
  beaconUrlHttps: string;
  agentVersion: string;
  localHosts: string[];
  enabledHost: string;
  useHTTPSAlways: boolean;
  spa: { spa2: boolean };
  xhr: { enabled: boolean };
  resTiming: { bufSize: number; clearResTimingOnBeaconSend: boolean };
  maxUrlLength: number;
  includeUrls: Array<{ pattern: string }>;
  excludeUrls: Array<{ pattern: string }>;
}

// Event type definitions for federation communication
export interface FederationEvents {
  [FederationEvent.AUTH_TOKEN_RECEIVED]: string | undefined;
  [FederationEvent.FEATURE_FLAGS_UPDATED]: FeatureFlagValues;
  [FederationEvent.APPD_CONFIG_UPDATED]: AppDynamicsConfigPayload;
  [FederationEvent.INTERCOM_AVAILABILITY_UPDATED]: boolean;
  [FederationEvent.INTERCOM_MESSENGER_AVAILABILITY_UPDATED]: boolean;
}

// Event payload type helper
export type EventPayload<T extends keyof FederationEvents> = FederationEvents[T];

// Event handler type
export type EventHandler<T extends keyof FederationEvents> = (payload: FederationEvents[T]) => void;

// Subscription cleanup function
export type Unsubscribe = () => void;

export interface OpenIntercomChatParams {
  prefilledMessage?: string;
  reason?: string;
  source?: 'aidi-questionnaire' | 'aidi-document-upload';
}

export interface FederationUtils {
  previewDocument: (params: PreviewDocumentParams) => Promise<void>;
  openIntercomChat: (params?: OpenIntercomChatParams) => void;
}
